module.exports = __webpack_public_path__ + "img/GAME_GATU2.03f11a52.jpg";